"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var use_context_selector_1 = require("use-context-selector");
var houston_styles_1 = tslib_1.__importDefault(require("@eduzz/houston-styles"));
var context_1 = require("../context");
var Content = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    var currentStep = (0, use_context_selector_1.useContextSelector)(context_1.ShowcaseContext, function (context) { return context.currentStep; });
    var stepSize = (0, use_context_selector_1.useContextSelector)(context_1.ShowcaseContext, function (context) { return context.stepSize; });
    var offset = (currentStep - 1) * -stepSize;
    return ((0, jsx_runtime_1.jsx)("div", tslib_1.__assign({}, rest, { style: { transform: "translateX(".concat(offset, "px)") } }, { children: children })));
};
exports.default = (0, houston_styles_1.default)(Content, { label: 'hst-showcase-content' })(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  position: relative;\n  top: 0;\n  left: 0;\n  transition: transform ease-in-out 0.5s;\n"], ["\n  display: flex;\n  position: relative;\n  top: 0;\n  left: 0;\n  transition: transform ease-in-out 0.5s;\n"])));
var templateObject_1;
